export const reviewModalContentStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 5,
		width: '100%'
	},

	noChangesText: {
		p: 2,
		color: 'text.secondary',
		fontStyle: 'italic'
	},

	attachmentsSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1,
		mb: 3
	},

	sectionTitle: {
		fontSize: '1.25rem',
		fontWeight: 700,
		color: 'text.primary'
	}
};
